module.exports = __webpack_public_path__ + "static/img/6_1.4be77024.jpg";